<template>
    <div>
        <el-dialog :visible.sync="positionDialog" width="40%" top="15vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false @close="closeDialog">
            <el-card>
                <el-table :data="response" style="margin:auto;width:calc(100% - 30px)" height="300" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                        :header-cell-style="{background:'#01DFD7',color:'#fff'}">
                    <el-table-column label="职位名称" align="center" prop="name"></el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button plain type="success" size="small" @click="modifyInfo(scope.row)">修改信息</el-button>
                            <el-button plain type="success" size="small" @click="getFunction(scope.row.id)">查看权限</el-button>
                            <el-button plain type="success" size="small" @click="delPosition(scope.row.id)">删除职位</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </el-dialog>
        <modify v-if="modifyDialog" ref="modify" @modify-succeed="modifySucceed"></modify>
        <function v-if="functionDialog" ref="function"></function>
        
    </div>
</template>
<script>
import {getPosition,delPosition} from '../../api/sys/position.js'
import Modify from './modify.vue'
import Function from './function.vue'
export default {
    components: {Modify,Function},
    data() {
        return {
            positionDialog: false,
            modifyDialog: false,
            functionDialog: false,
            response: [],
            id: ''
        }
    },
    methods: {
        init(id){
            this.positionDialog = true;
            this.id = id;
            getPosition(id).then(result=>{
                this.response = result.data;
            })
        },
        modifyInfo(row){
            this.modifyDialog = true;
            let item = {
                id: row.id,
                name: row.name,
                roleGroupId: row.roleGroupId,
                functions: row.functionIds,
                type: "position"
            }
            this.$nextTick(()=>{
                this.$refs.modify.init(item);
            })
        },
        modifySucceed(){
            this.init(this.id);
        },
        closeDialog(){
            this.positionDialog = false;
            this.modifyDialog = false;
            this.response = [];
            this.id = "";
        },
        delPosition(id){
        this.$confirm('确认是否操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            delPosition({id: id, type: "position"}).then(result=>{
                this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                });
                this.init(this.id);
            })
            })
        },
        getFunction(id){
            this.functionDialog = true;
            this.$nextTick(()=>{
                this.$refs.function.init({id: id,type: "position"});
            })
        }
    }
}
</script>
<style scpoed>

</style>


// WEBPACK FOOTER //
// src/pages/sys/postion.vue